import Vue from 'vue';
import filters from 'src/filters';
import App from 'src/app/App';
import uiComponents from 'components/ui';
import router from 'src/router';
import store from 'src/store';
import { i18n } from 'src/features';
import Shared from 'src/shared';
import vuetify from 'src/utils/vuetify';

Object.keys(filters).forEach((name) => Vue.filter(name, filters[name]));
Object.keys(uiComponents).forEach((name) => Vue.component(name, uiComponents[name]));

Vue.use(Shared);

Vue.config.productionTip = false;

const app = new Vue({
  i18n,
  store,
  router,
  vuetify,
  el: '#app',
  ...App,
});

export default app;
